<template>
  <div class="login_bg">
    <div class="ptc_container">
      <div class="login_contant">
        <h3 class="login_tit">로그인</h3>
        <p class="login_desc">서비스 이용을 위해서 로그인이 필요합니다.</p>
        <div class="login_form">
          <span>아이디</span>
          <input type="text" v-model="input.loginId" class="inp_id" placeholder="아이디를 입력하세요." />
          <span>비밀번호</span>
          <input type="password" v-model="input.password" class="inp_pw" placeholder="비밀번호를 입력하세요." @keydown="typingHandler" />
          <p class="idpw_save">
            <label for="chk01" class="component_checkbox">
              <input type="checkbox" id="chk01" v-model="saveId" />
              <span>아이디 저장</span>
            </label>
          </p>
          <button type="button" class="login_btn" @click="login">로그인</button>
        </div>
        <div class="login_common">
          <a href="/m3dhub/tutorial/Hub_Manual.pdf" class="tutorial_down">튜토리얼 다운로드</a>
          <div class="login_link">
            <b-btn variant="link" to="/account/find-id" style="padding: 0 0 0 10px; margin: 0 0 0 10px; border: none">아이디 찾기</b-btn>
            <b-btn variant="link" to="/account/find-pw" style="padding: 0 0 0 10px; margin: 0 0 0 10px; border: none">비밀번호 찾기</b-btn>
            <b-btn variant="link" to="/account/clear-idLock" style="padding: 0 0 0 10px; margin: 0 0 0 10px; border: none">계정잠금해제</b-btn>
          </div>
        </div>
        <p class="join_desc"><span>회원이 아니신가요?</span></p>
        <button type="button" class="join_btn" @click="doSignup">회원가입</button>
      </div>
    </div>
    <Popup :crntObj="{slotName:'checkInfo', obj: alertPopupInfo, closeHandler: alertClose}">
      <div :slot="'checkInfo'" class="checkUserInfo" >
        <p>
          아이디 혹은 비밀번호를 확인해 주세요.
        </p>
        <button @click="alertClose" class="confirm">확인</button>
      </div>
    </Popup>
  </div>
</template>

<script>
import MiddleContainer from "@/components/platform/MiddleContainer";
import ContentHeader from "@/components/platform/ContentHeader";
import Popup from "@/components/common/Popup";
import { Axios, AxiosError } from "axios";
export default {
  components: {
    MiddleContainer,
    ContentHeader,
  },
  data() {
    return {
      pending: false,
      input: {
        loginId: null,
        password: null,
      },
      saveId: false,
      alertPopupInfo:  {
        openBln:false
      }
    };
  },
  mounted() {
    localStorage.removeItem("m3dHubEditor__token");
    sessionStorage.removeItem("m3dHubEditor__token");
    const savedId = localStorage.getItem("m3dHubEditor__savedId");
    if (savedId) {
      this.input.loginId = savedId;
      this.saveId = true;
    }
  },
  methods: {
    typingHandler ( e ) {
      if ( e.key == 'Enter' ) {
        this.login() ; 
      }
    } ,
    doSignup () {
      this.$router.push(this.$route.params.redirect || "/account/signup");
    },
    async login() {
      // this.pending = true;

        const data = await this.$wApi.user.login(
          {
            loginId: this.input.loginId,
            password: this.input.password,
          },
          null,
          { useError: true }
        );
        // console.log( "data", data )
        if (data.accessToken) {
          const { accessToken } = data;
          localStorage.setItem("m3dHubEditor__token", accessToken);
          sessionStorage.setItem("m3dHubEditor__token", accessToken);
          if (this.saveId) {
            localStorage.setItem("m3dHubEditor__savedId", this.input.loginId);
          }
          const me = await this.$store.dispatch("getMe", this.$wApi);

          // if (me) this.$router.push(this.$route.params.redirect || "/platform");
          if (me) this.$router.push(this.$route.params.redirect || "/");
        } else if(data?.error) {
          if( data.failCount ) {
            if(data.failCount == 4) {
              window.alert(`로그인에 실패했습니다.<br/>아이디/비밀번호 찾기를 진행해주세요<br/>( 실패 횟수 ${data.failCount} ) `);
            }else{
              window.alert(`${data.message}<br/>( 실패 횟수 ${data.failCount} ) `);
            }
          }else if(data.isDormancy){
            window.alert(`${data.message}`);
            this.$router.push("/account/clear-idLock");
          }else{
            window.alert(`${data.message}`);
          }
          
        }
        // console.log(error)
        // this.pending = false;
    },
    alertClose() {
      this.alertPopupInfo.openBln = false;
    }
  },
};
</script>

<style>
@import "@/style/new/css/ui.reset.css";
@import "@/style/new/css/ui.common.css";
</style>
